import axios from '../services/axiosAuth';
import { ERROR, LOADING, COMPLETED, UNINITIALIZED } from './dataLoadedReducerCreator';
import { getProducts } from '../store/actions/brokerProducts';

export const initialize = (name) => (dispatch, getState) => {
  let role = getState()[name].role;
  if (!getState().authReducer.roles?.includes(role)) {
    return false;
  }

  let status = getState()[name].status;
  let endpoint = getState()[name].endpoint;
  if (status === UNINITIALIZED || status === ERROR) {
    dispatch({ type: name + '_' + LOADING });
    axios
      .get(endpoint)
      .then((r) => {
        if (name === 'userInfo') {
          window.mrkUserInfo = r.data;
        }

        dispatch({ type: name + '_' + COMPLETED, payload: r.data });
      })
      .catch(() => {
        dispatch({ type: name + '_' + ERROR });
      })
      .finally(() => {
        const getStatusOfUserInfo = getState()['userInfo']?.status;

        if (getStatusOfUserInfo === COMPLETED && name === 'userInfo') {
          dispatch(getProducts());

          return;
        }
      });
  }
};

export const reload = (name) => (dispatch, getState) => {
  let role = getState()[name].role;
  if (!getState().authReducer.roles?.includes(role)) {
    return false;
  }
  let endpoint = getState()[name].endpoint;
  axios
    .get(endpoint)
    .then((r) => {
      dispatch({ type: name + '_' + COMPLETED, payload: r.data });
    })
    .catch(() => {
      dispatch({ type: name + '_' + ERROR });
    });
};

export const clear = (name) => (dispatch) => dispatch({ type: name + '_' + UNINITIALIZED });
